import React, {} from 'react';
import { } from 'react-redux';
import { useTranslation, Trans } from "react-i18next";

import {
  Space,
  Button,
  Drawer,
  Divider
} from '@lockerpm/design';

import {
  InfoCircleOutlined,
  ArrowDownOutlined
} from '@ant-design/icons';

import { blue } from '@ant-design/colors';

import itemsComponents from '../../../../../components/items';

import global from '../../../../../config/global';
import { downloadCSV } from '../../../../../utils/common'

function FormData(props) {
  const { TextCopy } = itemsComponents;
  const {
    visible = false,
    mailConfig = null,
    members = [],
    currentPage = {},
    onClose = () => {},
  } = props
  const { t } = useTranslation()

  const handleDownload = async () => {
    const rows = [
      [t('common.email'), t('auth_pages.password')],
      ...members.map((m) => [m.username, m.password])
    ]
    downloadCSV(rows)
    onClose()
  }

  return (
    <div className={props.className}>
      <Drawer
        title={t('members.new')}
        placement="right"
        closable={!!mailConfig}
        open={visible}
        onClose={onClose}
        footer={
          <Space className='flex items-center justify-end'>
            <Button
              type="primary"
              onClick={handleDownload}
              icon={<ArrowDownOutlined />}
            >
              { t('button.download') } 
            </Button>
          </Space>
        }
      >
        <div>
          <p
            className='font-semibold text-lg'
          >
            {t('member.new_member_info')}
          </p>
          <p className='mb-4'>
            <Trans
              i18nKey='member.new_member_description'
              values={{
                mail: t('email_setting.title'),
              }}
              components={{
                mail: <a onClick={() => global.navigate('WORKSPACE_EMAIL_SETTING', { workspace_id: currentPage.params?.workspace_id })}></a>,
              }}
            />
          </p>
          {
            members.map((m, index) => <div key={index}>
              <TextCopy
                value={m.username}
              />
              <TextCopy
                show={false}
                align={'between'}
                value={m.password}
              />
              <Divider className='my-2'/>
            </div>)
          }
          <div className='flex mt-4'>
            <div style={{ color: blue[5] }} className='mr-2'>
              <InfoCircleOutlined />
            </div>
            <div>
              <Trans
                i18nKey='member.new_member_note'
                values={{
                  locker: t('locker.name'),
                  share: t('locker.quick_share')
                }}
                components={{
                  locker: <a href={global.urls.LOCKER_URL} target='_blank'/>,
                  share: <a href={global.urls.QUICK_SHARE_URL} target='_blank'/>
                }}
              />
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default FormData;
